import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

export const Description = ({
  className,
  ...props
}: { className?: string } & Omit<
  Headless.DescriptionProps,
  "as" | "className"
>): ReactElement => (
  <Headless.Description
    data-slot="description"
    {...props}
    className={clsx(
      className,
      "text-base/6 text-zinc-500 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-zinc-400",
    )}
  />
);
